<!-- BEGIN page-header -->
<div class="row">
    <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">
        <h1 class="page-header"><i class="fas fa-baby"></i> Prima Infantil</h1>

    </div>
    @if(budgetFund?.length>1){
        <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">
   
        <div class="btn-group">           
        @for(f of budgetFund; track f.id){
        <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}" [class.active]="fundSelect ==f.fundCode"  (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
        }
        </div>
      </div>
    }    
      
  
</div>
<!-- END page-header -->

<!-- BEGIN panel -->
<div class="panel " data-sortable-id="ui-widget-16">
    <div class="panel-heading ">
    </div>
    <div class="panel-body p-4">
        <div class="row">
            <div class="row mb-3 mt-2 align-items-center">
                <div class="col-6 col-md-6">
                    <ng-select [items]="dataListChildren" [selectableGroup]="true" [hideSelected]="true" [multiple]="true"
                        bindLabel="nameDiverse" [closeOnSelect]="false" [dropdownPosition]="'bottom'" bindValue="diverse"
                        placeholder="Buscar por diverso" [(ngModel)]="txtFind"
                        (change)="onCloseNgSelectFind()" tabindex="1">
                    </ng-select>
                </div>
                <div class="col-6 col-md-6 d-flex justify-content-end">
                    @if(budgetStatus==2){
                    <button class="btn btn-success btn-sm" (click)="openModalChildren()">Agregar
                        Prima</button>
                    }
                </div>
            </div>
            <div class=" mt-4">
                <div class="table-responsive table-data ">
                    <table class="table table-striped  table-sm ">
                        <thead>
                            <tr>
                                <th>Diverso</th>
                                <th>Funcionario</th>
                                <th>Nombre Hijo</th>
                                <th>Discapacidad</th>
                                <th>Fecha de Nacimiento</th>
                                <th>Edad Presupuestada</th>
                                <th>Prima Anual</th>
                                @if(budgetStatus==2){                                
                                <th><span class="d-flex justify-content-center"><i class="fa fa-cogs"></i></span></th>
                                }
                            </tr>
                        </thead>
                        @if(dataChildren?.length>0){
                        <tbody>
                            @for(d of dataChildren;track $index; let idx = $index){
                            <tr [ngClass]="{ 'custom-table-warning': d.fmrEmployee == 0 }">
                                <td>{{d.diverse}}</td>
                                <td>{{d.employee}}</td>
                                <td>{{d.names}}</td>                                
                                <td>@if(d.hasDisability){  Con discapacidad}</td>
                                <td>{{d.birthday}}</td>
                                <td>{{d.age}}</td>
                                <td>${{d.computedPremium| number:'1.0-0'}}</td>
                                @if(budgetStatus==2){
                                <td>

                                    <span class="d-flex justify-content-center">
                                        <button type="button" class="btn btn-outline-primary btn-xs "
                                            (click)="setFormChildren(d);"><i
                                                class="fa fa-pencil-alt"></i></button>&nbsp;

                                        <button type="button" class="btn btn-outline-danger btn-xs " placement="top"
                                            ngbTooltip="Eliminar" (click)="deleteChildren(d)"><i
                                                class="fa fa-trash"></i></button>
                                    </span>
                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="10">{{dataChildren?.length}} en Total</th>
                            </tr>
                        </tfoot>
                        }
                    </table>
                    @if(dataChildren?.length===0){
                    <div class="m-l-10 mb-2">
                        <em>Sin registros</em>
                    </div>
                    }
                </div>
            </div>

        </div>
    </div>
    <div class="hljs-wrapper">
        <pre><code class="html" data-url="../assets/data/ui-widget-boxes/code-16.json"></code></pre>
    </div>
</div>
<!-- END panel -->






<!--modal children-->

<ng-template #modal_children let-c="close" let-d="dismiss" let-modal>

    <div class="modal-header">
        <h5 class="modal-title">{{modalHeaderChildren}}</h5>
        <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
            <span>&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="panel-body panel-form">
            <form [formGroup]="formChildren">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Diverso</label>
                    <div class="col-md-8">
                        <ng-select #ngSelect [items]="dataListDiverse" [selectableGroup]="true" [hideSelected]="true"
                            bindLabel="nameDiverse" [closeOnSelect]="true" [dropdownPosition]="'bottom'"
                            bindValue="diverse" placeholder="Seleccionar diverso" formControlName="employeeCode"
                            name="employee_code" tabindex="1">
                        </ng-select>
                        @if(formChildren.get('employeeCode')?.errors?.required &&
                        formChildren.get('employeeCode').touched){
                        <div><small class="text-danger">Diverso es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Nombre Hijo</label>
                    <div class="col-md-8">
                        <input type="text" #nameInput [class.is-invalid]="false" formControlName="names" names="names"
                            class="form-control" tabindex="2" />
                        @if(formChildren.get('names')?.errors?.required && formChildren.get('names').touched){
                        <div><small class="text-danger">Nombre del hijo es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Fecha de Nacimiento</label>
                    <div class="col-md-8">
                        <input type="date" name="" id="" class="form-control" formControlName="birthday">
                        @if(formChildren.get('birthday')?.errors?.required && formChildren.get('birthday').touched){
                        <div><small class="text-danger">Fecha de nacimiento es requerido.</small></div>
                        }
                        @if(formChildren.controls['birthday'].hasError('dateInvalid')){
                        <div><small class="text-danger">La fecha no puede ser mayor a 5 meses.</small></div>
                        }

                    </div>
                </div>
                &nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Discapacidad</label>
                    <div class="col-md-8">
                        <input type="checkbox" name="" id="" class="form-check-input" formControlName="hasDisability" >

                    </div>
                </div>

            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click')" tabindex="6"><i
                class="fas fa-times"></i>&nbsp; Cerrar</button>
        @if(modalHeaderChildren==='Nuevo'){
        <button type="button" class="btn btn-primary btn-sm" (click)="submitChildrenNew()"
            [disabled]="formChildren.pristine&&!formChildren.valid||!formChildren.valid" tabindex="5"><i
                class="fas fa-save"></i>&nbsp;Guardar</button>
        }
        @if(modalHeaderChildren==='Modificar'){
        <button type="button" class="btn btn-primary btn-sm" (click)="submitChildrenUpdate()"
            [disabled]="formChildren.pristine||!formChildren.valid" tabindex="5"><i
                class="fas fa-save"></i>&nbsp;Guardar</button>
        }

    </div>
</ng-template>
<!--end Children-->